import styled from 'styled-components';

export const StyledDescriptionText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
`;
